// src/screens/EliminarPOI.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { eliminarPOIPorNombre } from '../api/api'; // Ajusta la ruta a tu archivo de API

const EliminarPOI: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEliminar = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const msg = await eliminarPOIPorNombre(name);
      setMessage(msg); 
    } catch (err: any) {
      setError(err.message || 'Error al eliminar el POI');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '20px' }}>
      <h1>Eliminar POI</h1>
      <div style={{ marginBottom: 10 }}>
        <label>Nombre del POI a eliminar:</label>
        <br />
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>

      <button onClick={handleEliminar} disabled={loading || !name}>
        {loading ? 'Eliminando...' : 'Eliminar'}
      </button>

      {message && (
        <div style={{ marginTop: 20, color: '#509E2F' }}>
          <strong>{message}</strong>
        </div>
      )}

      {error && (
        <div style={{ marginTop: 20, color: '#EF3340' }}>
          <strong>{error}</strong>
        </div>
      )}

     
    </div>
  );
};

export default EliminarPOI;
